import React from 'react'
import PropTypes from 'prop-types'
import { ProgressBar } from 'react-bootstrap'
import { EMPTY_VALUE, TONE } from '../../data/constants'
import styles from './ScoreProgress.module.scss'

const clampPercent = (value) => Math.max(0, Math.min(100, Math.round(value)))
const getVisualPercent = ({ disabled, hasValue, percent }) => {
  if (disabled) return 100
  if (hasValue && percent === 0) return 1
  return percent
}

export default function ScoreProgress({
  value = null,
  tone = TONE.NEUTRAL,
  showValue = true,
  reserveValueSpace = true,
  size = 'default',
  disabled = false,
}) {
  const hasValue = !disabled && Number.isFinite(value)
  const percent = hasValue ? clampPercent(value) : 0
  const visualPercent = getVisualPercent({ disabled, hasValue, percent })
  const valueTone = hasValue ? tone : TONE.NEUTRAL
  const progressClasses = [
    styles.progress,
    'd-grid align-items-center gap-2',
    styles[size],
    disabled ? styles.disabled : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={progressClasses}>
      <ProgressBar
        now={visualPercent}
        min={0}
        max={100}
        className={`${styles.track} ${styles[valueTone] ?? ''}`}
        barClassName={styles.fill}
      />
      {showValue && (
        <div className={`${styles.value} ${styles[valueTone] ?? ''}`}>
          {hasValue ? (
            <>
              {percent}
              <small>%</small>
            </>
          ) : (
            EMPTY_VALUE
          )}
        </div>
      )}
      {!showValue && reserveValueSpace && !disabled && (
        <div className={`${styles.value} ${styles.valueSpacer}`} aria-hidden="true">
          0<small>%</small>
        </div>
      )}
    </div>
  )
}

ScoreProgress.propTypes = {
  value: PropTypes.number,
  tone: PropTypes.oneOf(Object.values(TONE)),
  showValue: PropTypes.bool,
  reserveValueSpace: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'compact']),
  disabled: PropTypes.bool,
}
